module.exports = __webpack_public_path__ + "img/hans-granerud-l.656ef15f.webp";